export default __webpack_public_path__ + "static/media/sortArrow.1b37e92e.svg";